import React, { Component, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {Button, TextField, Grid, Typography, FormControl, FormLabel, FormGroup, FormControlLabel, Switch, IconButton } from '@mui/material'
import Api from '../../../../services/api'
import * as Service from '../../../../services/calledservicesettingsvalidation.service'
import { FormattedMessage, injectIntl } from 'react-intl'
import SimpleHelp from "../../../../components/help"
import SimpleCheckBox from '../../../../components/checkbox/check'
import Tooltip from '@mui/material/Tooltip'
import HelpIcon from '@mui/icons-material/Help'
import { PapiroConsole } from '../../../../utils/papiroConsole'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as componentActions from '../../../../redux/actions/calledservicesettingsvalidations'
import { DataGrid, GridActionsCellItem, GridToolbarFilterButton  } from '@mui/x-data-grid'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import DialogConfirmation from '../../../../components/dialog-confirmation'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ClearIcon from '@mui/icons-material/Clear'
import EditIcon from '@mui/icons-material/Edit';
import AddCalledServiceSettingsValidationItemDialog from './addItemDialog'
import UpdateCalledServiceSettingsValidationItemDialog from './updateItemDialog'

function CalledServiceSettingsValidations(props) {

  const { classes, intl, userId, hirerId, calledServiceSettingsId } = props

  const [calledServiceSettingsValidationList, setCalledServiceSettingsValidationList] = useState([])
  const [calledServiceSettingsValidationListForDelete, setCalledServiceSettingsValidationListForDelete] = useState([])
  const [calledServiceSettingsValidationInsertDialogOpen, setCalledServiceSettingsValidationInsertDialogOpen] = useState(false)
  const [calledServiceSettingsValidationUpdateDialogOpen, setCalledServiceSettingsValidationUpdateDialogOpen] = useState(false)

  const [itemEditData, setItemEditData] = useState(null)

  useEffect(() => {
    if (props.calledservicesettingsvalidations && props.calledservicesettingsvalidations.calledservicesettingsvalidationslist && props.calledservicesettingsvalidations.calledservicesettingsvalidationslist.length > 0)
      setCalledServiceSettingsValidationList(props.calledservicesettingsvalidations.calledservicesettingsvalidationslist)
  }, [props.calledservicesettingsvalidations])

  const NoDataRows = _ => {
    return (
      <div className="MuiDataGrid-window" style={{ display: 'flex', justifyContent: 'center', top: 56, overflowY: 'auto' }} >{intl.formatMessage({id:"rows.show"})}</div>
    )
  }

  const setCalledServiceSettingsValidationDelete = calledServiceSettingsValidation => setCalledServiceSettingsValidationListForDelete(calledServiceSettingsValidation)

  const handleOpenCalledServiceSettingsValidationInsertModal = isOpen => setCalledServiceSettingsValidationInsertDialogOpen(isOpen)

  const handleOpenCalledServiceSettingsValidationUpdateModal = isOpen => {
    setCalledServiceSettingsValidationUpdateDialogOpen(isOpen)
    if (!isOpen)
      setItemEditData(null)
  }

  const calledServiceSettingsValidationDeleteModal = async _ => {
    let idList = ""
    calledServiceSettingsValidationListForDelete.map(id => {
      idList += `${id},`
    })

    if (idList.length > 0) {
      props.setLoading(true)
      let response = await Service.deleteItems(idList)
      if (response && response.success) {
        let notIdList = props.calledservicesettingsvalidations.calledservicesettingsvalidationslist.filter(item => !calledServiceSettingsValidationListForDelete.includes(item.id))
        if (notIdList != null) {
          let loopOrder = 0
          let notIdListOrdened = notIdList.sort((a, b) => a.id - b.id)
          let notIdListFinal = notIdListOrdened.map(item => {
            return {
              ...item,
              order: ++loopOrder
            }
          })
          props.addCalledServiceSettingsValidationsList(notIdListFinal)
        } else
          props.addCalledServiceSettingsValidationsList([])
        setCalledServiceSettingsValidationListForDelete([])
        props.setLoading(false)
        props.setMessage(true, 'success', intl.formatMessage({ id: "delete.sucess" }))
      } else {
        props.setLoading(false)
        props.setMessage(true, 'error', intl.formatMessage({ id: "process.error" }))
        Api.kickoff(response)
      }
    }
  }

  const editItem = (params) => {
    PapiroConsole.log("=== editItem ===")
    PapiroConsole.log(params)
    props.addCalledServiceSettingsValidation(params.row)
    setItemEditData(params.row)
    handleOpenCalledServiceSettingsValidationUpdateModal(true)
  }

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} style={{ padding: 10, display: 'flex', flexDirection: 'row', backgroundColor: '#eee' }} >
        <Grid xs={12} sm={6} style={{ margin: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} >
          { calledServiceSettingsValidationListForDelete.length > 0 && <DialogConfirmation
            msgButton="Remover validação?"
            msg="Você tem certeza que deseja remover esta validação?"
            msgDisagree={intl.formatMessage({id:"cancel"})}
            msgAgree={intl.formatMessage({id:"yes"})}
            handleConfirmation={e => calledServiceSettingsValidationDeleteModal()}
            classes={classes}
            icon={<DeleteIcon />} />}
        </Grid>
        <Grid xs={12} sm={6} style={{ margin: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} >
          <Button
            variant="contained"
            color="primary"
            fullWidth
            className={classes.button}
            startIcon={<AddIcon />}
            onClick={e => handleOpenCalledServiceSettingsValidationInsertModal(true)} >
            Adicionar validação
          </Button>
        </Grid>
      </Grid>
      <Grid xs={12} sm={12}
        style={{
          border: '3px solid #eee'
        }} >
        <div style={{ height: 350 }}>
          <DataGrid
            style={{ fontSize: 14, color: '#000' }}
            className="DataGridStyle"
            components={{
              NoRowsOverlay: NoDataRows,
              Toolbar: GridToolbarFilterButton,
            }}
            rows={calledServiceSettingsValidationList}
            rowsPerPageOptions={[10, 25, 50]}
            checkboxSelection
            onSelectionModelChange={itm => {
              if (itm.length > 0) {
                PapiroConsole.log("=== onSelectionModelChange ===")
                PapiroConsole.log(itm)
                setCalledServiceSettingsValidationDelete(itm);
              } else {
                setCalledServiceSettingsValidationListForDelete([])
              }
            }}
            columns={[
              {
                headerName: intl.formatMessage({id:"edit"}),
                field: "actions",
                renderCell: (params) => (
                  <IconButton
                    arya-label="edit"
                    onClick={() => editItem(params)} >
                    <EditIcon />
                  </IconButton>
                )
              },
              { headerName: intl.formatMessage({ id: "title" }), field: 'title', width: 600 },
              { headerName: intl.formatMessage({ id: "active" }), field: 'IsActive', width: 100 }
            ]}
          />
        </div>
      </Grid>
      <AddCalledServiceSettingsValidationItemDialog
        open={calledServiceSettingsValidationInsertDialogOpen}
        handleOpen={handleOpenCalledServiceSettingsValidationInsertModal}
        itemsCount={calledServiceSettingsValidationList?.length}
        userId={userId}
        hirerId={hirerId}
        calledServiceSettingsId={calledServiceSettingsId} />
      <UpdateCalledServiceSettingsValidationItemDialog
        open={calledServiceSettingsValidationUpdateDialogOpen}
        handleOpen={handleOpenCalledServiceSettingsValidationUpdateModal}
        itemsCount={calledServiceSettingsValidationList?.length}
        userId={userId}
        hirerId={hirerId}
        calledServiceSettingsId={calledServiceSettingsId}
        itemData={itemEditData} />
    </Grid>
  )
}

CalledServiceSettingsValidations.propTypes = {
  userId: PropTypes.number.isRequired,
  hirerId: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
  calledServiceSettingsId: PropTypes.number.isRequired,
  intl: PropTypes.object.isRequired,
  setLoading: PropTypes.func.isRequired,
  setMessage: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  calledservicesettingsvalidations: state.calledservicesettingsvalidations,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CalledServiceSettingsValidations))